<template>
  <li class="item">
    <slot></slot>
  </li>
</template>
<script>
  export default {
    name: 'fish-carousel-item',
    data () {
      return {
      }
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CarouselItem.vue